var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-error-codes" },
    [
      _c(
        "div",
        { staticClass: "search-container" },
        [
          _c(
            "a-input",
            {
              attrs: { placeholder: "Hata mesajı ara...", allowClear: true },
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            },
            [
              _c("a-icon", {
                attrs: { slot: "prefix", type: "search" },
                slot: "prefix",
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-collapse",
        {
          attrs: { accordion: "" },
          model: {
            value: _vm.activeKey,
            callback: function ($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey",
          },
        },
        _vm._l(_vm.filteredErrors, function (error, index) {
          return _c(
            "a-collapse-panel",
            { key: index, attrs: { header: error.originalError } },
            [
              _c(
                "div",
                { staticClass: "error-description" },
                [
                  _c("div", { staticClass: "description-tr" }, [
                    _c("strong", [_vm._v("🇹🇷 Türkçe:")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(error.descriptions.tr))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "description-en" }, [
                    _c("strong", [_vm._v("🇬🇧 English:")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(error.descriptions.en))]),
                  ]),
                  _vm._v(" "),
                  _c("a-alert", {
                    staticClass: "meta-link-alert",
                    attrs: { type: "info", "show-icon": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "message",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  "\n                            Daha fazla detay için\n                            "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/",
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Meta'yı ziyaret edin\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }